import React from 'react';
import '../css/CalculationExplanation.css';

const CalculationExplanation = ({ onClose }) => {
  return (
    <div className="explanation-overlay">
      <div className="explanation-content">
        <h2>How We Calculate Solar Panel Installation Figures</h2>
        <p>
          Here's a brief explanation of how we calculate the figures:
        </p>
        <p>
          The solar panel calculator takes user inputs like average monthly electricity usage, panel wattage, number of sun hours, system losses, and inverter efficiency to estimate the total system size needed to meet household electricity needs. Based on these inputs, we calculate the daily energy usage and then derive the necessary system capacity, expressed in kilowatts (kW). We then also determines the number of panels required by dividing the system size by the individual panel wattage.
        </p>
        <p>
          The total cost of the installation is computed by multiplying the system size by both panel and installation costs per watt. The value of any subsidy schemes can be subtracted from this total cost to give the net cost of the system. Adjustments for roof pitch, orientation, and shading are factored in to determine the efficiency of energy generation. Finally, we calculate annual savings, estimated power generation, and payback time, considering the amount of electricity consumed by you and the portion of generated electricity exported to the grid.
        </p>
        <button onClick={onClose} className="close-button">Close</button>
      </div>
    </div>
  );
};

export default CalculationExplanation;

